// TopBar-specific icons
import React from 'react';

export const ThemeIcon = ({ dark }: { dark: boolean }) =>
  dark ? (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21 12.79A9 9 0 1 1 11.21 3a7 7 0 1 0 9.79 9.79z" stroke="#fff" strokeWidth="2" fill="none" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="5" stroke="#fff" strokeWidth="2" fill="none" />
      <path
        d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
        stroke="#fff"
        strokeWidth="2"
      />
    </svg>
  );

export const GlobeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="#fff" strokeWidth="2" fill="none" />
    <ellipse cx="12" cy="12" rx="4" ry="10" stroke="#fff" strokeWidth="2" fill="none" />
    <line x1="2" y1="12" x2="22" y2="12" stroke="#fff" strokeWidth="2" />
  </svg>
);

export const SpeakerIcon = () => (
  <svg width="22" height="22" viewBox="0 0 32 32">
    <defs>
      <clipPath id="clip-speaker">
        <rect width="32" height="32" />
      </clipPath>
    </defs>
    <g id="speaker" clipPath="url(#clip-speaker)">
      <g id="Group_3382" data-name="Group 3382" transform="translate(-416)">
        <g id="Group_3375" data-name="Group 3375">
          <g id="Group_3368" data-name="Group 3368">
            <g id="Group_3367" data-name="Group 3367">
              <g id="Group_3366" data-name="Group 3366">
                <path
                  id="Path_4047"
                  data-name="Path 4047"
                  d="M433.313,31.875a1,1,0,0,1-.679-1.733c.339-1.042.8-5.993.8-14.142s-.461-13.1-.8-14.142a1,1,0,0,1,.679-1.733c.9,0,2.121,0,2.121,15.875S434.208,31.875,433.313,31.875Z"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="Group_3371" data-name="Group 3371">
          <g id="Group_3370" data-name="Group 3370">
            <g id="Group_3369" data-name="Group 3369">
              <path
                id="Path_4048"
                data-name="Path 4048"
                d="M433.333,31.875c-5.4-.008-10.275-3.332-12.73-8.673a.994.994,0,0,1-.09-.379c-.083-2.157-.125-4.453-.125-6.823s.042-4.666.125-6.823a.994.994,0,0,1,.09-.379c2.455-5.341,7.325-8.665,12.711-8.673.906.016,2.12.037,2.12,15.875S434.22,31.859,433.333,31.875ZM422.5,22.544a12.234,12.234,0,0,0,10.205,7.313c.328-1.485.726-6.293.726-13.857s-.4-12.374-.726-13.858A12.231,12.231,0,0,0,422.5,9.456c-.076,2.073-.115,4.273-.115,6.544S422.427,20.471,422.5,22.544Z"
                fill="#fff"
              />
            </g>
          </g>
        </g>
        <g id="Group_3374" data-name="Group 3374">
          <g id="Group_3373" data-name="Group 3373">
            <g id="Group_3372" data-name="Group 3372">
              <path
                id="Path_4049"
                data-name="Path 4049"
                d="M421.512,23.784h-1.446a3.55,3.55,0,0,1-3.546-3.546V11.762a3.55,3.55,0,0,1,3.546-3.546h1.446a1,1,0,1,1,0,2h-1.446a1.548,1.548,0,0,0-1.546,1.546v8.476a1.548,1.548,0,0,0,1.546,1.546h1.446a1,1,0,0,1,0,2Z"
                fill="#fff"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Group_3378" data-name="Group 3378">
        <g id="Group_3377" data-name="Group 3377">
          <g id="Group_3376" data-name="Group 3376">
            <path
              id="Path_4050"
              data-name="Path 4050"
              d="M437.968,22.369a1,1,0,0,1-.517-1.857,6.5,6.5,0,0,0,0-11.149,1,1,0,1,1,1.031-1.714,8.5,8.5,0,0,1,0,14.577A.991.991,0,0,1,437.968,22.369Z"
              fill="#fff"
            />
          </g>
        </g>
      </g>
      <g id="Group_3381" data-name="Group 3381">
        <g id="Group_3380" data-name="Group 3380">
          <g id="Group_3379" data-name="Group 3379">
            <path
              id="Path_4051"
              data-name="Path 4051"
              d="M441.477,25.879a1,1,0,0,1-.6-1.8,11.377,11.377,0,0,0,0-18.277,1,1,0,0,1,1.191-1.606,13.376,13.376,0,0,1,0,21.489A.99.99,0,0,1,441.477,25.879Z"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const LogoutIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Door */}
    <path
      d="M10 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Arrow */}
    <path
      d="M14 8l4 4-4 4"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 12H10"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

